import "../src/scroll_down_catalog"

var componentRequireContext = require.context("components", true, /front\/catalog\/*/);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);
